import { identity } from 'ramda';

export type InputKeyboardEventMatcher = (event: KeyboardEvent) => boolean;

export const defaultMatcher: InputKeyboardEventMatcher = () => identity(true);
